import React from 'react';
import IconCross from '../icons/IconCross';

const ButtonClear = ({name, onClick}) => {

  return (
    <button className="btn btn--clear" onClick={onClick}>
      <IconCross color="black" width="10"/>
      <span className="btn--clear__label">{name ? name : 'Clear Filters'}</span>
    </button>
  );
}

export default ButtonClear;